module.exports = __webpack_public_path__ + "static/media/Facilitatoraaron.13909af3.jpeg";